import { render } from "./VariablesSection.vue?vue&type=template&id=216143b5"
import script from "./VariablesSection.vue?vue&type=script&lang=js"
export * from "./VariablesSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__